var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 44H5C2.244 44 0 41.758 0 39V25C0 24.86 0.03 24.718 0.088 24.59L8.026 6.95C8.834 5.158 10.624 4 12.586 4H35.414C37.376 4 39.166 5.158 39.974 6.95L47.912 24.59C47.97 24.718 48 24.86 48 25V39C48 41.758 45.756 44 43 44ZM2 25.214V39C2 40.654 3.346 42 5 42H43C44.654 42 46 40.654 46 39V25.214L38.15 7.768C37.666 6.696 36.592 6 35.414 6H12.586C11.408 6 10.334 6.696 9.85 7.77L2 25.214Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.614 34H14.386C13.142 34 12.014 33.218 11.578 32.054L9.55 26.648C9.406 26.26 9.03 26 8.614 26H1.5C0.948 26 0.5 25.552 0.5 25C0.5 24.448 0.948 24 1.5 24H8.614C9.858 24 10.986 24.782 11.424 25.946L13.45 31.352C13.596 31.74 13.972 32 14.386 32H33.612C34.028 32 34.404 31.74 34.548 31.352L36.574 25.946C37.014 24.782 38.142 24 39.386 24H47C47.552 24 48 24.448 48 25C48 25.552 47.552 26 47 26H39.386C38.97 26 38.594 26.26 38.45 26.648L36.424 32.054C35.986 33.218 34.856 34 33.614 34Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFolder);
export default __webpack_public_path__ + "static/media/empty-folder.66429a19a030163de9211da68a4de75a.svg";
export { ForwardRef as ReactComponent };